import * as React from 'react';
import AdditionalDataFormComponent, { AdditionalComponentProps } from './AdditionalDataForm.component';
import ApiClient from 'src/services/api-client/ApiClient';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';
import EnumTypes from 'src/services/EnumStates/EnumTypes';

export interface AdditionalContainerProps {
    formData: PhysicalPersonData;
    handleChange: (key: string) => (value: string | File | boolean) => void;
}

class AdditionalDataFormContainer extends React.Component<AdditionalContainerProps> {

    public state = {
        maritalStatusOptions: [],
        maritalTypeOptions: [],
        maritalEconomicStatus: [],
        maritalProfession: [],
    };

    public componentWillMount(): void {
        ApiClient.constants.indexMaritalStatuses()
            .then(
                (response) => {
                    const states = [];
                    for (let key of Object.keys(response.data.data)) {
                        states.push({
                          name: EnumTypes.getMaritalStatusName(response.data.data[key]),
                          value: key.toString()
                        });
                    }
                    this.setState({
                        maritalStatusOptions: states,
                    });
                }
            );

        ApiClient.constants.indexTypeStatuses()
            .then(
                (response) => {
                    const states = [];
                    for (let key of Object.keys(response.data.data)) {
                        states.push({
                          name: EnumTypes.getMaritalPropertyRegimeName(response.data.data[key]),
                          value: key.toString()
                        });
                    }
                    this.setState({
                        maritalTypeOptions: states,
                    });
                }
            );

        ApiClient.constants.indexEconomicStatuses()
            .then(
                (response) => {
                    const states = [];
                    for (let key of Object.keys(response.data.data)) {
                        states.push({
                          name: EnumTypes.getMaritalEconomicStatusName(response.data.data[key]),
                          value: key.toString()
                        });
                    }
                    this.setState({
                        maritalEconomicStatus: states,
                    });
                }
            );

        ApiClient.constants.indexProfessions()
            .then(
                (response) => {
                    const states = [];
                    for (let key of Object.keys(response.data.data)) {
                        states.push({
                          name: EnumTypes.getOccupationTypesName(response.data.data[key]),
                          value: key.toString()
                        });
                    }
                    this.setState({
                        maritalProfession: states,
                    });
                }
            );
    }

    public render(): React.ReactNode {
        return (
            <AdditionalDataFormComponent {...this.getComponentProps()} />
        );
    }

    private getComponentProps(): AdditionalComponentProps {
        return {
            handleChange: (key: string) => this.props.handleChange(key),
            formData: this.props.formData!,
            maritalStatusOptions: this.state.maritalStatusOptions,
            maritalTypeOptions: this.state.maritalTypeOptions,
            maritalEconomicStatus: this.state.maritalEconomicStatus,
            maritalProfession: this.state.maritalProfession,
        };
    }
}

export default AdditionalDataFormContainer;



// WEBPACK FOOTER //
// ./src/modules/my-account/physical-person-update/forms/AdditionalDataForm.container.tsx